'use strict';

// @flow

import React from 'react';
import type {Node} from 'react';

import type {FlowReportMetaProps} from './html-report-page';

const HTMLReportFooter = (props: FlowReportMetaProps): Node => {
  return (
    <footer>
      Flow Coverage Report generated by
      {' '}
      <a href="https://flowtype.org">flow</a>
      {' '}
      and
      {' '}
      <a href="https://github.com/rpl/flow-coverage-report">flow-coverage-report</a>
      {' '}
      at {props.coverageGeneratedAt}
    </footer>
  );
};

export default HTMLReportFooter;
